import { ORGAN_TYPES } from '@features/components/CaseFormBlocks/config';
import { OrganType } from '@/api/apis/case';
import { OrganSpecificDonorProfileFormValues } from './types';

export type OrganDataFormValues = OrganSpecificDonorProfileFormValues;

export type OrganDataByOrgan = Partial<Record<OrganType, OrganDataFormValues>>;

export const ORGAN_DATA_FIELD = 'organData';

export const organDataFieldPrefix = (organType: OrganType) => `${ORGAN_DATA_FIELD}.${organType}.`;

export const organDataIssuePath = (organType: OrganType): string[] => [ORGAN_DATA_FIELD, organType];

export const ORGAN_NAME_BY_TYPE = ORGAN_TYPES.reduce(
  (names, { value, name }) => ({ ...names, [value]: name }),
  {} as Record<OrganType, string>,
);
